import React, { useState } from "react";
import { SwitchOption } from "@src/lms/jelly/extensions/ui";
import { useIntl } from "react-intl";

import { messages } from "./VirtualAcoustics.messages";
import styles from "./VirtualAcoustics.module.scss";
import { SimpleLayoutView } from "@src/lms/jelly/extensions/layouts/simple/SimpleLayoutView";

import { Slide1 } from "./slides/Slide1/Slide1";
import { Slide2 } from "./slides/Slide2/Slide2";
import { Slide3 } from "./slides/Slide3/Slide3";
import { Slide4 } from "./slides/Slide4/Slide4";

interface VirtualAcoustics {
  title: string;
}

export const VirtualAcoustics: React.FC<VirtualAcoustics> = () => {
  const { formatMessage } = useIntl();
  const [selectedOption, setSelectedOption] = useState(0);

  const renderSlide = (): JSX.Element => {
    switch (selectedOption) {
      case 0:
        return <Slide1 />;
      case 1:
        return <Slide2 />;
      case 2:
        return <Slide3 />;
      case 3:
        return (
          <Slide4
            title={formatMessage(messages.G6_P5_S4_Title)}
            description={formatMessage(messages.G6_P5_S4_Theory_Description)}
            videoUrl="https://youtu.be/KS5WW4i5nUI"
            videoCaption={formatMessage(messages.G6_P5_S4_Theory_Image_Caption)}
          />
        );
      case 4:
        return (
          <Slide4
            title={formatMessage(messages.G6_P5_S5_Title)}
            description={formatMessage(messages.G6_P5_S5_Theory_Description)}
            videoUrl="https://youtu.be/sCJTvQisczY"
            videoCaption={formatMessage(messages.G6_P5_S5_Theory_Image_Caption)}
          />
        );
      case 5:
        return (
          <Slide4
            title={formatMessage(messages.G6_P5_S6_Title)}
            description={formatMessage(messages.G6_P5_S6_Theory_Description)}
            videoUrl="https://youtu.be/PCQAaQm4aSM"
            videoCaption={formatMessage(messages.G6_P5_S6_Theory_Image_Caption)}
          />
        );

      case 6:
        return (
          <Slide4
            title={formatMessage(messages.G6_P5_S7_Title)}
            description={formatMessage(messages.G6_P5_S7_Theory_Description)}
            videoUrl="https://youtu.be/vNZkDQnxIpw"
            videoCaption={formatMessage(messages.G6_P5_S7_Theory_Image_Caption)}
          />
        );

      case 7:
        return (
          <Slide4
            title={formatMessage(messages.G6_P5_S8_Title)}
            description={formatMessage(messages.G6_P5_S8_Theory_Description)}
            videoUrl="https://youtu.be/7DU2xhmvWKg"
            videoCaption={formatMessage(messages.G6_P5_S8_Theory_Image_Caption)}
          />
        );

      default:
        return <Slide1 />;
    }
  };

  return (
    <SimpleLayoutView>
      <div className={styles.VirtualAcoustics}>
        <div className={styles.rightComponent}>
          <div className={styles.slide}>{renderSlide()}</div>
          <div className={styles.switch}>
            <SwitchOption
              onClick={setSelectedOption}
              activeItem={selectedOption}
              items={[
                {
                  name: formatMessage(messages.G6_P5_S1_Name),
                },
                {
                  name: formatMessage(messages.G6_P5_S2_Name),
                },
                {
                  name: formatMessage(messages.G6_P5_S3_Name),
                },
                {
                  name: formatMessage(messages.G6_P5_S4_Name),
                },
                {
                  name: formatMessage(messages.G6_P5_S5_Name),
                },
                {
                  name: formatMessage(messages.G6_P5_S6_Name),
                },
                {
                  name: formatMessage(messages.G6_P5_S7_Name),
                },
                {
                  name: formatMessage(messages.G6_P5_S8_Name),
                },
              ]}
            />
          </div>
        </div>
      </div>
    </SimpleLayoutView>
  );
};
